export default function formatarData(dataString) {
  if (dataString) {
    const [ano, mes, dia] = dataString.substring(0, "yyyy-mm-dd".length).split("-");
    return `${dia}/${mes}/${ano}`;
  } else {
    return dataString;
  }
}
